import React from 'react';
import { motion } from 'framer-motion';
import { Waves } from './Waves';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-ocean-900" data-id="element-50">
      {/* Background Gradients */}
      <div className="absolute inset-0 bg-gradient-to-b from-ocean-400/40 via-ocean-800 to-ocean-900 z-0" data-id="element-51"></div>

      {/* Sun Glow at Horizon */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-sun-500/30 blur-[120px] rounded-full z-0 pointer-events-none" data-id="element-52"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center pb-32" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-54">
          <img src="https://cdn.magicpatterns.com/uploads/376XfgufppoCzctQV4w12y/bwc_temp_logo.jpg" alt="BWC Boat Deck Restoration" className="w-48 md:w-64 rounded-2xl shadow-2xl shadow-ocean-900/50 border-4 border-white/10" data-id="element-55" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-tight mb-6" data-id="element-56">
          Transforming Your Deck,
          <br data-id="element-57" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-sun-400 to-sun-500" data-id="element-58">
            One Wave at a Time.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-xl md:text-2xl text-ocean-100 font-medium mb-10 max-w-2xl" data-id="element-59">
          No job too small, no job too big. Premium boat deck restoration
          serving South Florida.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-60">
          <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full text-ocean-900 bg-gradient-to-r from-sun-400 to-sun-500 hover:from-sun-300 hover:to-sun-400 transition-all transform hover:-translate-y-1 shadow-xl shadow-sun-500/30" data-id="element-61">
            Get a Free Quote
          </a>
        </motion.div>
      </div>

      {/* Animated Waves transitioning to the next section (white) */}
      <Waves className="bottom-0 z-20" fill="fill-white" data-id="element-62" />
    </section>;
}